import React, { Component } from "react";
import { Descriptions, Dropdown, Select, Row, Col, Table } from "antd";
import { strings } from "../../../helpers";
const { Option } = Select;

export default class LocationsView extends Component {
  render() {
    const { details, navigateToClinicDetails } = this.props;

    const columns = [
      {
        title: "Name",
        align: "left",
        dataIndex: "name",
        key: "name"
      },
      {
        title: "Address",
        dataIndex: "location",
        key: "location",
        align: "left",
        render: record => {
          return (
            <>
              {record && record.address_line_1 && (
                <div>{record.address_line_1}</div>
              )}
            </>
          );
        }
      },
      {
        title: "City",
        dataIndex: "location",
        key: "location",
        align: "left",
        render: record => {
          return <>{record && record.city && <div>{record.city}</div>}</>;
        }
      },
      {
        title: "State",
        dataIndex: "location",
        key: "location",
        align: "left",
        render: record => {
          return <>{record && record.state && <div>{record.state}</div>}</>;
        }
      },
      ,
      {
        title: "Zipcode",
        dataIndex: "location",
        key: "location",
        align: "left",
        render: record => {
          return <>{record && record.state && <div>{record.zipcode}</div>}</>;
        }
      }
    ];
    return (
      <div>
        <Row type="flex" justify="space-between" align="middle">
          <Col span={5} className="heading-domain">
            My Location
          </Col>
        </Row>
        <Descriptions layout="vertical" bordered>
          <Descriptions.Item label={strings.clinic.city}>
            {(details && details.location && details.location.city) || "--"}
          </Descriptions.Item>
          <Descriptions.Item label={strings.clinic.pincode}>
            {(details && details.location && details.location.zipcode) || "--"}
          </Descriptions.Item>
          <Descriptions.Item label={strings.clinic.address} span={18}>
            {(details && details.location && details.location.address_line_1) ||
              "--"}
          </Descriptions.Item>
          <Descriptions.Item label={"state"} span={18}>
            {(details && details.location && details.location.state) || "--"}
          </Descriptions.Item>
        </Descriptions>
        <div className="content-container">
          <div className="backgroundWhite">
            <Row type="flex" justify="space-between" align="middle">
              <Col span={5} className="heading-domain">
                Other Locations
              </Col>
            </Row>

            <div className="mt-20 kc-block white-bg round-borders-4x">
              <Table
                onRowClick={record => navigateToClinicDetails(record.id)}
                columns={columns}
                dataSource={details.clinic_group}
                pagination={false}
                rowKey="id"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
